import type { IFormInputs } from "types/uiSchema";

export interface IPersonalData {
    firstName: IFormInputs | null;
    lastName: IFormInputs | null;
    email: IFormInputs | null;
    phone: IFormInputs | null;
}

// todo: to delete
export const extractPersonalData = (elements: IFormInputs[]): IPersonalData => {
    const personalDataKeys = ["firstName", "lastName", "email", "phone"] as const;
    type PersonalDataKeys = (typeof personalDataKeys)[number];

    const initialData: IPersonalData = {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
    };

    return elements.reduce((acc, element) => {
        if (element["x-control-name"] === "PersonalData2" && element.elements) {
            element.elements.forEach((subElement) => {
                const key = subElement["x-json-schema-reference-property" as keyof typeof subElement] as PersonalDataKeys;

                if (personalDataKeys.includes(key)) Object.assign(acc, { [key]: subElement });
            });
        }

        return acc;
    }, initialData);
};

export const extractPersonalFields = (elements: IFormInputs["elements"]): IPersonalData => {
    const personalDataKeys = ["firstName", "lastName", "email", "phone"] as const;
    type PersonalDataKeys = (typeof personalDataKeys)[number];

    const initialData: IPersonalData = {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
    };

    elements?.forEach((element) => {
        const key = element["x-json-schema-reference-property"] as PersonalDataKeys;

        if (personalDataKeys.includes(key)) Object.assign(initialData, { [key]: element });
    });

    return initialData;
};
